/* eslint-disable import/prefer-default-export */
import config from '@/service/contant/config';
import request from '@/service/request';
import api from '@/service/contant/api';

export const getWxAppId = data => request({
  url: api.wxPay.getWxAppId,
  method: 'GET',
  data,
});
export const getRedirectUrl = data => request({
  url: api.wxPay.getRedirectUrl,
  method: 'GET',
  params: data,
});
export const getOpenId = data => request({
  url: api.wxPay.getOpenId,
  method: 'GET',
  params: data,
});
// export const getOpenId = params => fetch(`${api.wxPay.getOpenId + params}`);
export function createOrder(data, opt = {}) {
  return request({
    url: api.detail.createOrder,
    method: 'POST',
    data: { appId: config.platformId, ...data },
    ...opt,
  });
}
// 轮询
export function checkPayProgress(data, opt = {}) {
  return request({
    url: api.detail.payProgress,
    method: 'POST',
    data,
    ...opt,
  });
}
// wxConfig
export function getWxConfig(params, opt = {}) {
  return request({
    url: api.wxPay.getWxConfig,
    method: 'GET',
    params,
    ...opt,
  });
}
// 邮费支付
export function orderCreate(data, opt = {}) {
  return request({
    url: api.myBox.orderCreate,
    method: 'POST',
    data,
    ...opt,
  });
}
